import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../services/translation.service';

export const DAY_LABEL_KEY = 'Día {{n}}';

/**
 * HRS-3833: "Día 1", "Día 2"… con el orden que marque el diccionario
 * ("1. eguna" en euskera). Sin la clave en el idioma, `fallback`, que es
 * lo que cada sitio pintaba antes.
 */
export function translateDayLabel(
  translationService: TranslationService,
  n: number,
  fallback: () => string
): string {
  const label = translationService.instant(DAY_LABEL_KEY, { n });
  return label && label !== DAY_LABEL_KEY ? label : fallback();
}

@Pipe({
  name: 'dayLabel',
  standalone: true,
  // Impuro como el pipe translate: se reevalúa al cambiar de idioma
  pure: false,
})
export class DayLabelPipe implements PipeTransform {
  private _translationService = inject(TranslationService);

  transform(n: number): string {
    return translateDayLabel(this._translationService, n, () => `${this._translationService.instant('Día')} ${n}`);
  }
}
